import { render, staticRenderFns } from "./LibraryNewBooks.vue?vue&type=template&id=6282ff60&scoped=true&"
import script from "./LibraryNewBooks.vue?vue&type=script&lang=js&"
export * from "./LibraryNewBooks.vue?vue&type=script&lang=js&"
import style0 from "./LibraryNewBooks.vue?vue&type=style&index=0&id=6282ff60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282ff60",
  null
  
)

export default component.exports